import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class LimitApplicationsService {
  authToken: any;
  user: any;
  baseURI: string;

  constructor(private http: HttpClient, private auth: AuthService) {
    this.baseURI = this.auth.baseURL;
  }

  loadToken() {
    const token = localStorage.getItem('bUser_token');
    this.authToken = token;
    const user = localStorage.getItem('user');
    this.user = user;
  }

  getLimitApplications(params = {}) {
    return this.http.get(this.baseURI + 'limit-applications', {
      params,
    });
  }

  // getLimitApplications(params) {
  //   let headers: HttpHeaders = new HttpHeaders();
  //   this.loadToken();
  //   console.log(this.authToken)
  //   headers = headers.append('Authorization', this.authToken);
  //   headers = headers.append('Content-Type', 'application/json');
  //   return this.http.get(this.baseURI + 'limit-applications', {
  //     headers: headers,
  //     params,
  //   });
  // }

  getLimitApplicationDetails(id, params = {}) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    // return this.http.get(this.baseURI + `limit-applications/${id}`, {
    //   headers: headers,
    // });
    return this.http.get(this.baseURI + `limit-applications/${id}`, {
      params,
    });
  }

  approveByMaker(id, data) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    return this.http.post(this.baseURI + `limit-applications/${id}/maker-approve`, data);
  }

  approveByChecker(id, data) {
    // let headers: HttpHeaders = new HttpHeaders();
    // this.loadToken();
    // headers = headers.append('Authorization', this.authToken);
    // headers = headers.append('Content-Type', 'application/json');
    // return this.http.post(
    //   this.baseURI + `limit-applications/${id}/checker-approve`,
    //   data,
    //   {
    //     headers,
    //   }
    // );
    return this.http.post(this.baseURI + `limit-applications/${id}/checker-approve`, data);
  }

  reject(id) {
    return this.http.post(this.baseURI + `limit-applications/${id}/reject`, null);
    //   let headers: HttpHeaders = new HttpHeaders();
    //   this.loadToken();
    //   headers = headers.append('Authorization', this.authToken);
    //   headers = headers.append('Content-Type', 'application/json');
    //   return this.http.post(
    //     this.baseURI + `limit-applications/${id}/reject`,
    //     null,
    //     {
    //       headers,
    //     }
    //   );
  }
}
